import React from 'react';
import { compose } from 'recompose';
import {
    autoCompleteDefaultLifeCycle,
    autoCompletePickerPropTypes,
    autoCompleteWithHandlerLoadData,
    autoCompleteWithHandlers,
    autoCompleteWithStateHandlers,
} from '../helpers/autoComplete';
import { fetchSearchPlayers as apiFetchSearchPlayers } from '../../../../front-v2/services/api';

const autoCompletePlayerHOC = AutoComplete =>
    compose(
        autoCompletePickerPropTypes(),
        autoCompleteWithStateHandlers(),
        autoCompleteWithHandlerLoadData(apiFetchSearchPlayers, 300),
        autoCompleteWithHandlers(
            data => ({
                playerId: data.id,
            }),
            true,
        ),
        autoCompleteDefaultLifeCycle(),
    )(props => <AutoComplete {...props} />);

export default autoCompletePlayerHOC;



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/pickers/hoc/autoCompletePlayerHOC.js
 **/